import { render, staticRenderFns } from "./ContentBox.vue?vue&type=template&id=028446b8&scoped=true"
import script from "./ContentBox.vue?vue&type=script&lang=js"
export * from "./ContentBox.vue?vue&type=script&lang=js"
import style0 from "./ContentBox.vue?vue&type=style&index=0&id=028446b8&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028446b8",
  null
  
)

export default component.exports